import React, { useState } from 'react'
import { Card, Col, Row } from 'react-bootstrap'
import VideoPlayerModal from '../../common/VideoPlayerModal';

const VRHealthCare = () => {
    const [modalShow, setModalShow] = useState(false);
    const [videoUrl, setVideoUrl] = useState(null)

    const openVideoModal = (data) => {
        setModalShow(true)
        setVideoUrl(data)

    }
  return (
    <>
    
        <Card className='text-center no-border rounded-0 industrial-modeling-top-section container pt-4 pt-md-5'>
            <Card.Body>
                <Card.Title className='industrial-modeling-title'> ヘルスケア向けVR </Card.Title>
                <Card.Text className='industrial-environment-text text-left'>
                International VR for Healthcare Associationの設立メンバーである当社は、ヘルスケア分野のクライアントを多く抱えています。ヘルスケアのためのVRアプリケーションは、健康な患者に対しては実施できないような手術のトレーニングから、臨床試験を経ている行動療法や物理療法まで、多岐にわたります。
                <br /> <br />
                外科医の中には、特定の手術を滅多に行わない人もいますし、患者は不慣れな手術をされたくないでしょう。VRシミュレーションは、外科医が生身の人間に手術を行う前に、レアケースの手術方法を安全に訓練し、再確認することに役立ちます。
                </Card.Text>
            </Card.Body>
            <Row className='pt-md-5'>
                <Col xs={{span:12, offset:0}} md={{span:5, offset:0}}>
                    <Card.Title className='vr-healthcare-title'> VR手術トレーニング </Card.Title>
                    <Card.Text className='text-left vr-healthcare-text'>
                    外科開業医のために、物理とアニメーションをミックスした腹腔鏡下胆嚢摘出術（通称：胆嚢摘出術）のVRシミュレーションを作成しました。
                    </Card.Text>
                </Col>
                <Col xs={{span:12, offset:0}} md={{span:7, offset:0}}>
                    <Card className='no-border rounded-0 container healthcare-video-container product-video-section' onClick={() => openVideoModal('/assets/vr-development/healthcare/video/Surgery.mp4')}>
                        <Card.Img className='img img-thumbnail' src={"/assets/vr-development/healthcare/images/health-care-banner.jpg"} />
                        <Card.ImgOverlay className='playicon-overlay-center'>
                            <Card.Img src={"/assets/icons/video-player.png"} />
                        </Card.ImgOverlay>

                    </Card>
                </Col>
                </Row>
                <Row className='px-md-4'>
                <Col xs={{span:4, offset:0}} className="no-padding-x pt-md-4">
                    <Card.Img className='img img-thumbnail' src={"/assets/vr-development/healthcare/images/001.jpg"} />
                </Col>
                <Col xs={{span:4, offset:0}} className="no-padding-x pt-md-4">
                    <Card.Img className='img img-thumbnail' src={"/assets/vr-development/healthcare/images/002.jpg"} />
                </Col>
                <Col xs={{span:4, offset:0}} className="no-padding-x pt-md-4">
                    <Card.Img className='img img-thumbnail' src={"/assets/vr-development/healthcare/images/003.jpg"} />
                </Col>
            </Row>
        </Card>
        <VideoPlayerModal
        show={modalShow}
        onHide={() => setModalShow(false)}
        videosrc={videoUrl}
      />
    </>
  )
}

export default VRHealthCare
